import {
  PaymentMethod,
  PaymentPlan,
  PaymentSchedule,
} from "@covertree/new-business-graphql";
import { PaymentPlanKey } from "../types";

const paymentPlanKeyToPaymentSchedule: Record<PaymentPlanKey, PaymentSchedule> =
  {
    annual: PaymentSchedule.FullPay,
    semiAnnual: PaymentSchedule.TwoPay,
    monthly: PaymentSchedule.ElevenPay,
    mortgageBill: PaymentSchedule.MortgageBill,
  };

export function mapPaymentPlanKeyToPaymentSchedule(
  paymentPlanKey: PaymentPlanKey
): PaymentSchedule {
  return paymentPlanKeyToPaymentSchedule[paymentPlanKey];
}

export function mapStripePaymentMethodToPaymentMethod(
  stripePaymentMethod: string
): PaymentMethod {
  switch (stripePaymentMethod) {
    case "us_bank_account":
      return PaymentMethod.BankAccount;
    case "card":
      return PaymentMethod.CreditDebitCard;
    default:
      throw new Error(`Unknown stripe payment method: ${stripePaymentMethod}`);
  }
}

export function getTotalCostFromPaymentPlan(plan: PaymentPlan): number {
  return (
    Math.round(
      plan.installments.reduce((acc, installment) => {
        return acc + installment.fees + installment.taxes + installment.premium;
      }, 0) * 100
    ) / 100
  );
}
